module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-72x72-a82dc8d4fcd4626514e28b700870cb84.png";